// NotificationContext.ts
import React from "react";

export const NotificationContext = React.createContext<any>(null);